import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';

import CarImage from "../CarComponent/CarImageComponent";

const CarDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  font-size: 0.6em;
  width: 75%;
`;

const Car = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  cursor: pointer;
  &:hover {
    background: #d3d3d373;
  }
`;


const CarComponent = props => {

    return (
        <Tooltip title="Lista najmów samochodu" placement="bottom">
            <Car onClick={() => props.onSelectedCarClick()}>
                <CarImage url={props.car.obraz}/>
                <CarDetails className={"drag-lock"}>
                    <div>
                        <div>
                            {props.car.marka} {props.car.model}
                        </div>
                        <div>nr rej: {props.car.rejestracja}</div>
                        <div>Przebieg: {props.car.dystans}</div>
                        <div>Paliwo: {props.car.procent_paliwo}</div>
                        <div>Opis: {props.car.opis}</div>
                    </div>
                </CarDetails>
            </Car>
        </Tooltip>

    );
};

export default CarComponent;
